import Vue from 'vue'
import axios from 'axios'
import ViewUI from 'view-design'
import App from './App'
import store from './store'
import Apis from './api'
import AvueUeditor from 'avue-plugin-ueditor'
import router from './router'
import Element from 'element-ui';
import 'view-design/dist/styles/iview.css'
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import Print from 'vue-print-nb'
import reg from '@/utils/reg'
import * as echarts from 'echarts';
import iconPicker from 'e-icon-picker';
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui 图标库
import "e-icon-picker/lib/symbol.js"; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
import './permission'
import VueViewer, { directive as viewerDirective } from 'v-viewer';
import 'viewerjs/dist/viewer.css'; // 图片预览器的样式
Vue.use(VueViewer, {
  defaultOptions: {
      /**
       *  数字含义:
       *  0 or false: hide the navbar
          1 or true: show the navbar
          2: show the navbar only when the screen width is greater than 768 pixels
          3: show the navbar only when the screen width is greater than 992 pixels
          4: show the navbar only when the screen width is greater than 1200 pixels
       */
      toolbar: {
          zoomIn: 0,
          zoomOut: 0,
          oneToOne: 0,
          reset: 0,
          prev: {
              show: 4,
              size: 'large',
          },
          play: 0,
          next: {
              show: 4,
              size: 'large',
          },
          rotateLeft: 0,
          rotateRight: 0,
          flipHorizontal: 0,
          flipVertical: 0,
      },
      zoomRatio: 0.3 // 缩放比率 默认是0.1
  }
}); // 图片预览器
// 用于图片预览的指令方式调用 在元素上加上会处理元素下所有的图片,为图片添加点击事件,点击即可预览
Vue.directive('viewer', viewerDirective({
  debug: true
}));

Vue.use(iconPicker, {
    FontAwesome: false,
    ElementUI: true,
    eIcon: false,//自带的图标，来自阿里妈妈
    eIconSymbol: false,//是否开启彩色图标
    addIconList: [],
    removeIconList: [],
    zIndex: 3100
});
Vue.use(Print)
Vue.use(Avue, { axios });
Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.prototype.$Apis = Apis
Vue.prototype.$axios = axios;
Vue.prototype.$reg = reg;
Vue.use(AvueUeditor);
Vue.use(Element)
Vue.prototype.$echarts = echarts

const vm = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})